module.exports = __webpack_public_path__ + "img/quizz-step-8-1.1ad8760d.jpg";